import { render, staticRenderFns } from "./PlanningCard.vue?vue&type=template&id=107d3afb&scoped=true&"
import script from "./PlanningCard.vue?vue&type=script&lang=ts&"
export * from "./PlanningCard.vue?vue&type=script&lang=ts&"
import style0 from "./PlanningCard.vue?vue&type=style&index=0&id=107d3afb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107d3afb",
  null
  
)

export default component.exports